<ion-card
  class="movie-item"
  [class.desktop-device]="desktopDevice"
  [routerLink]="'/movie/' + movie.id">
  <ng-container
    *ngIf="movie.poster_file || movie.poster?.url; else placeholderPoster">
    <app-img-format
      *ngIf="movie?.poster_file"
      [src]="movie.poster_file"
      [alt]=""
      [aspectRatio]="'89:132'"
      [disableLazyLoad]="true"></app-img-format>
    <app-img-format
      *ngIf="movie?.poster?.url"
      [src]="movie.poster.url"
      [alt]="movie?.poster?.alt || ''"
      [aspectRatio]="'89:132'"
      [disableLazyLoad]="true"></app-img-format>
  </ng-container>
  <ng-template #placeholderPoster>
    <app-img-format
      src="/assets/placeholder-movie.png"
      alt=""
      [aspectRatio]="'89:132'"
      [disableLazyLoad]="true"></app-img-format>
  </ng-template>
  <ion-card-header>
    <ng-container *ngIf="cinemaProvider?.slug === 'numetro'; else skProvider">
      <img
        *ngIf="movie.is_2d === '1' || movie.is_3d === '1'"
        src="/assets/icon-movie-standard.png"
        alt=""
        width="48"
        height="48"
        loading="lazy" />
      <img
        *ngIf="movie.is_vip === '1'"
        src="/assets/icon-movie-vip.png"
        alt=""
        width="48"
        height="48"
        loading="lazy" />
      <img
        *ngIf="movie.is_xtreme === '1'"
        src="/assets/icon-movie-xtreme.png"
        alt=""
        width="48"
        height="48"
        loading="lazy" />
      <img
        *ngIf="movie.is_4dx === '1'"
        src="/assets/icon-movie-4dx.png"
        alt=""
        width="48"
        height="48"
        loading="lazy" />
    </ng-container>

    <ng-template #skProvider>
      <img
        *ngIf="
          movie.experiences.includes('3D IMAX') ||
          movie.experiences.includes('2D IMAX')
        "
        src="/assets/icon-movie-imax.png"
        alt=""
        class="icon-larger"
        width="60"
        height="12"
        loading="lazy" />
    </ng-template>

    <ng-container *ngIf="cinemaProvider?.slug === 'numetro'; else skMovie">
      <ion-card-subtitle>
        {{ movie.age_restriction }}
      </ion-card-subtitle>
    </ng-container>
    <ng-template #skMovie>
      <ion-card-subtitle>
        <div
          *ngIf="movie.experiences && movie.experiences[0]"
          class="tag-listing">
          <ion-text *ngIf="movie.experiences.includes('Nouveu')"
            >Nouveu</ion-text
          >
          <ion-text *ngIf="movie.experiences.includes('3D IMAX')"
            >3D IMAX</ion-text
          >
          <ion-text *ngIf="movie.experiences.includes('3D')">3D</ion-text>
          <ion-text *ngIf="movie.experiences.includes('2D IMAX')"
            >2D IMAX</ion-text
          >
          <ion-text *ngIf="movie.experiences.includes('2D')">2D</ion-text>
        </div>
        {{ movie.rating }}
      </ion-card-subtitle>
    </ng-template>
    <ion-card-title>
      {{ movie.title }}
      <ion-icon name="caret-forward-circle"></ion-icon>
    </ion-card-title>
  </ion-card-header>
</ion-card>
